<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
      scrollable
    >
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
          <v-toolbar-title>
            {{ json_data.save_type == 'create' ? $t('menu.ConditionsCreate') : $t('menu.ConditionsEdit')
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout
              row
              wrap
              pa-4
              style="background-color:#fff; margin-top:5px; border-radius:5px;"
            >
              <v-flex md12 sm12 xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md3 sm3 xs12 class="px-1">
                      <v-text-field
                        name="รหัสโปรไฟล์"
                        label="รหัสโปรไฟล์"
                        :readonly="json_data.save_type != 'create'"
                        v-model="form_model.code"
                        :rules="form_rules.code"
                        append-icon="fa-plus-circle"
                        @click:append="doNewGuid"
                      />
                    </v-flex>
                    <v-flex md3 sm3 xs12 class="px-1">
                      <v-text-field
                        name="ชื่อโปรไฟล์"
                        v-model="form_model.name"
                        :rules="form_rules.name"
                        label="ชื่อโปรไฟล์"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h3>การหักเงิน</h3>
                    </v-flex>
                    <v-flex xs12 class="px-4 mt-3">
                      <h3>กรณี ขาดงาน</h3>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-radio-group v-model="form_model.deduct_absent_bytime" row>
                            <v-radio label="คิดแบบชั่วโมงทำงาน" value="0" />
                            <v-radio label="คิดแบบวันทำงาน" value="1" />
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันจันทร์"
                                label="วันจันทร์(เท่า)"
                                v-model="form_model.deduct_absent_monday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_absent_monday = Math.max(Math.abs(form_model.deduct_absent_monday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันอังคาร"
                                label="วันอังคาร(เท่า)"
                                v-model="form_model.deduct_absent_tuesday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_absent_tuesday = Math.max(Math.abs(form_model.deduct_absent_tuesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันพุธ"
                                label="วันพุธ(เท่า)"
                                v-model="form_model.deduct_absent_wednesday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_absent_wednesday = Math.max(Math.abs(form_model.deduct_absent_wednesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันพฤหัสบดี"
                                label="วันพฤหัสบดี(เท่า)"
                                v-model="form_model.deduct_absent_thursday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_absent_thursday = Math.max(Math.abs(form_model.deduct_absent_thursday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันศุกร์"
                                label="วันศุกร์(เท่า)"
                                v-model="form_model.deduct_absent_friday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_absent_friday = Math.max(Math.abs(form_model.deduct_absent_friday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันเสาร์"
                                label="วันเสาร์(เท่า)"
                                v-model="form_model.deduct_absent_saturday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_absent_saturday = Math.max(Math.abs(form_model.deduct_absent_saturday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันอาทิตย์"
                                label="วันอาทิตย์(เท่า)"
                                v-model="form_model.deduct_absent_sunday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_absent_sunday = Math.max(Math.abs(form_model.deduct_absent_sunday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันหยุด"
                                label="วันหยุด(เท่า)"
                                v-model="form_model.deduct_absent_holiday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_absent_holiday = Math.max(Math.abs(form_model.deduct_absent_holiday),0)"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="px-4 mt-3">
                      <h3>กรณี ลางาน</h3>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-radio-group v-model="form_model.deduct_leave_bytime" row>
                            <v-radio label="คิดแบบชั่วโมงทำงาน" value="0" />
                            <v-radio label="คิดแบบวันทำงาน" value="1" />
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันจันทร์"
                                label="วันจันทร์(เท่า)"
                                v-model="form_model.deduct_leave_monday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_leave_monday = Math.max(Math.abs(form_model.deduct_leave_monday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันอังคาร"
                                label="วันอังคาร(เท่า)"
                                v-model="form_model.deduct_leave_tuesday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_leave_tuesday = Math.max(Math.abs(form_model.deduct_leave_tuesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันพุธ"
                                label="วันพุธ(เท่า)"
                                v-model="form_model.deduct_leave_wednesday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_leave_wednesday = Math.max(Math.abs(form_model.deduct_leave_wednesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันพฤหัสบดี"
                                label="วันพฤหัสบดี(เท่า)"
                                v-model="form_model.deduct_leave_thursday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_leave_thursday = Math.max(Math.abs(form_model.deduct_leave_thursday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันศุกร์"
                                label="วันศุกร์(เท่า)"
                                v-model="form_model.deduct_leave_friday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_leave_friday = Math.max(Math.abs(form_model.deduct_leave_friday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันเสาร์"
                                label="วันเสาร์(เท่า)"
                                v-model="form_model.deduct_leave_saturday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_leave_saturday = Math.max(Math.abs(form_model.deduct_leave_saturday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันอาทิตย์"
                                label="วันอาทิตย์(เท่า)"
                                v-model="form_model.deduct_leave_sunday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_leave_sunday = Math.max(Math.abs(form_model.deduct_leave_sunday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันหยุด"
                                label="วันหยุด(เท่า)"
                                v-model="form_model.deduct_leave_holiday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_leave_holiday = Math.max(Math.abs(form_model.deduct_leave_holiday),0)"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="px-4 mt-3">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <h3>กรณี มาสาย(นาที)</h3>
                        </v-flex>
                        <v-flex md9 sm9 xs12>
                          <v-radio-group
                            v-model="form_model.late_conditional"
                            @click="changeconditional()"
                            row
                          >
                            <v-radio label="ไม่มีเงื่อนไข" v-bind:value="0" hide-details />
                            <v-radio label="มีเงื่อนไข" v-bind:value="1" hide-details />
                          </v-radio-group>
                        </v-flex>
                        <v-flex md3 sm3 xs12 v-if="form_model.late_conditional == '1'">
                          <v-btn color="green" dark @click="addlistconditionlate()">
                            <v-icon size="16" class="px-2">fa-plus</v-icon>
                            <span>เพิ่มเงื่อนไข</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap v-if="form_model.late_conditional  == '0'">
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-radio-group v-model="form_model.deduct_late_bytime" row>
                                <v-radio label="หักเงินตามรายรับ(นาที)" value="0" />
                                <v-radio label="หักเงินตามจำนวน" value="1" />
                              </v-radio-group>
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                v-model="form_model.deduct_late_monday"
                                name="วันจันทร์"
                                label="วันจันทร์(เท่า)"
                                type="number"
                                @change="form_model.deduct_late_monday = Math.max(Math.abs(form_model.deduct_late_monday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                v-model="form_model.deduct_late_tuesday"
                                name="วันอังคาร"
                                label="วันอังคาร(เท่า)"
                                type="number"
                                @change="form_model.deduct_late_tuesday = Math.max(Math.abs(form_model.deduct_late_tuesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                v-model="form_model.deduct_late_wednesday"
                                name="วันพุธ"
                                label="วันพุธ(เท่า)"
                                type="number"
                                @change="form_model.deduct_late_wednesday = Math.max(Math.abs(form_model.deduct_late_wednesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                v-model="form_model.deduct_late_thursday"
                                name="วันพฤหัสบดี"
                                label="วันพฤหัสบดี(เท่า)"
                                type="number"
                                @change="form_model.deduct_late_thursday = Math.max(Math.abs(form_model.deduct_late_thursday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                v-model="form_model.deduct_late_friday"
                                name="วันศุกร์"
                                label="วันศุกร์(เท่า)"
                                type="number"
                                @change="form_model.deduct_late_friday = Math.max(Math.abs(form_model.deduct_late_friday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                v-model="form_model.deduct_late_saturday"
                                name="วันเสาร์"
                                label="วันเสาร์(เท่า)"
                                type="number"
                                @change="form_model.deduct_late_saturday = Math.max(Math.abs(form_model.deduct_late_saturday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                v-model="form_model.deduct_late_sunday"
                                name="วันอาทิตย์"
                                label="วันอาทิตย์(เท่า)"
                                type="number"
                                @change="form_model.deduct_late_sunday = Math.max(Math.abs(form_model.deduct_late_sunday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                v-model="form_model.deduct_late_holiday"
                                name="วันหยุด"
                                label="วันหยุด(เท่า)"
                                type="number"
                                @change="form_model.deduct_late_holiday = Math.max(Math.abs(form_model.deduct_late_holiday),0)"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap v-if="form_model.late_conditional == '1'">
                        <v-flex xs12>
                          <v-layout
                            row
                            wrap
                            v-for="(item,i) in form_model.list_condition_late"
                            :key="i"
                          >
                            <v-flex md2 sm3 xs6 pa-2>
                              <v-text-field
                                v-model="item.timein"
                                label="ตั้งแต่เวลา"
                                type="time"
                                @blur="checktimelate(item,i)"
                              />
                            </v-flex>
                            <v-flex md2 sm3 xs6 pa-2>
                              <v-text-field
                                v-model="item.timeout"
                                label="ถึงเวลา"
                                type="time"
                                @blur="checktimelate(item,i)"
                              />
                            </v-flex>
                            <v-flex md2 sm3 xs6 pa-2>
                              <v-select
                                required
                                :items="listcondition"
                                item-text="text"
                                item-value="code"
                                label="ประเภทการจ่ายเงิน"
                                v-model="item.deducttype"
                                @input="paymenttype => updatepaymenttype(paymenttype,i)"
                              />
                            </v-flex>
                            <v-flex md2 sm2 xs6 pa-2>
                              <v-text-field
                                v-model="item.amount"
                                type="number"
                                label="จำนวน"
                                hide-details
                                :min="0"
                                @change="item.amount = Math.max(Math.abs(item.amount),0)"
                              />
                            </v-flex>
                            <v-flex
                              md2
                              sm1
                              xs6
                              pa-3
                              v-if="form_model.list_condition_late.length > 1"
                            >
                              <v-icon
                                size="16"
                                color="red"
                                @click="dellistconditionlate(i)"
                              >fa-minus</v-icon>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="px-4 mt-3">
                      <h3>กรณี ออกก่อน(นาที)</h3>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-radio-group v-model="form_model.deduct_outbefore_bytime" row>
                            <v-radio label="หักเงินตามรายรับ(นาที)" value="0" />
                            <v-radio label="หักเงินตามจำนวน" value="1" />
                          </v-radio-group>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันจันทร์"
                                label="วันจันทร์(เท่า)"
                                v-model="form_model.deduct_outbefore_monday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_outbefore_monday = Math.max(Math.abs(form_model.deduct_outbefore_monday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันอังคาร"
                                label="วันอังคาร(เท่า)"
                                v-model="form_model.deduct_outbefore_tuesday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_outbefore_tuesday = Math.max(Math.abs(form_model.deduct_outbefore_tuesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันพุธ"
                                label="วันพุธ(เท่า)"
                                v-model="form_model.deduct_outbefore_wednesday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_outbefore_wednesday = Math.max(Math.abs(form_model.deduct_outbefore_wednesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันพฤหัสบดี"
                                label="วันพฤหัสบดี(เท่า)"
                                v-model="form_model.deduct_outbefore_thursday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_outbefore_thursday = Math.max(Math.abs(form_model.deduct_outbefore_thursday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันศุกร์"
                                label="วันศุกร์(เท่า)"
                                v-model="form_model.deduct_outbefore_friday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_outbefore_friday = Math.max(Math.abs(form_model.deduct_outbefore_friday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันเสาร์"
                                label="วันเสาร์(เท่า)"
                                v-model="form_model.deduct_outbefore_saturday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_outbefore_saturday = Math.max(Math.abs(form_model.deduct_outbefore_saturday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันอาทิตย์"
                                label="วันอาทิตย์(เท่า)"
                                v-model="form_model.deduct_outbefore_sunday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_outbefore_sunday = Math.max(Math.abs(form_model.deduct_outbefore_sunday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันหยุด"
                                label="วันหยุด(เท่า)"
                                v-model="form_model.deduct_outbefore_holiday"
                                type="number"
                                :min="0"
                                @change="form_model.deduct_outbefore_holiday = Math.max(Math.abs(form_model.deduct_outbefore_holiday),0)"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                      <v-flex xs12 class="px-4 mt-3">
                      <h3>กรณี ลืมสแกนนิ้วออกงาน</h3>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex md2 sm3 xs6 pa-2>
                             <v-select
                                required
                                :items="listcondition"
                                item-text="text"
                                item-value="code"
                                label="ประเภทการจ่ายเงิน"
                                v-model="form_model.forgetscan_type"
                              />
                            </v-flex>
                            <v-flex md2 sm2 xs6 pa-2>
                               <v-text-field
                                v-model="form_model.forgetscan_value"
                                type="number"
                                label="จำนวน"
                                hide-details
                                :min="0"
                                @change="form_model.forgetscan_value = Math.max(Math.abs(form_model.forgetscan_value),0)"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h3>รายการรับ</h3>
                    </v-flex>
                    <v-flex xs12 class="px-4 mt-3">
                      <h3>โอที(ชั่วโมง)</h3>
                      <v-flex xs12>
                          <v-radio-group v-model="form_model.income_ot_bytime"  row>
                            <v-radio label="ได้เงินตามรายรับ(ชั่วโมง)" value="0" />
                            <v-radio label="ได้เงินตามจำนวน" value="1" />
                          </v-radio-group>
                        </v-flex>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันจันทร์"
                                label="วันจันทร์(เท่า)"
                                v-model="form_model.income_ot_monday"
                                type="number"
                                :min="0"
                                @change="form_model.income_ot_monday = Math.max(Math.abs(form_model.income_ot_monday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันอังคาร"
                                label="วันอังคาร(เท่า)"
                                v-model="form_model.income_ot_tuesday"
                                type="number"
                                :min="0"
                                @change="form_model.income_ot_tuesday = Math.max(Math.abs(form_model.income_ot_tuesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันพุธ"
                                label="วันพุธ(เท่า)"
                                v-model="form_model.income_ot_wednesday"
                                type="number"
                                :min="0"
                                @change="form_model.income_ot_wednesday = Math.max(Math.abs(form_model.income_ot_wednesday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันพฤหัสบดี"
                                label="วันพฤหัสบดี(เท่า)"
                                v-model="form_model.income_ot_thursday"
                                type="number"
                                :min="0"
                                @change="form_model.income_ot_thursday = Math.max(Math.abs(form_model.income_ot_thursday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันศุกร์"
                                label="วันศุกร์(เท่า)"
                                v-model="form_model.income_ot_friday"
                                type="number"
                                :min="0"
                                @change="form_model.income_ot_friday = Math.max(Math.abs(form_model.income_ot_friday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันเสาร์"
                                label="วันเสาร์(เท่า)"
                                v-model="form_model.income_ot_saturday"
                                type="number"
                                :min="0"
                                @change="form_model.income_ot_saturday = Math.max(Math.abs(form_model.income_ot_saturday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันอาทิตย์"
                                label="วันอาทิตย์(เท่า)"
                                v-model="form_model.income_ot_sunday"
                                type="number"
                                :min="0"
                                @change="form_model.income_ot_sunday = Math.max(Math.abs(form_model.income_ot_sunday),0)"
                              />
                            </v-flex>
                            <v-flex md1 sm2 xs6 class="px-1">
                              <v-text-field
                                name="วันหยุด"
                                label="วันหยุด(เท่า)"
                                v-model="form_model.income_ot_holiday"
                                type="number"
                                :min="0"
                                @change="form_model.income_ot_holiday = Math.max(Math.abs(form_model.income_ot_holiday),0)"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="px-4 mt-3">
                      <v-layout row wrap>
                        <v-flex lg9 md9 sm9 xs6>
                          <h3>เบี้ยขยัน</h3>
                        </v-flex>
                         <!-- <v-flex xs12>
                          <v-radio-group  row>
                            <v-radio label="ช่วงเวลา" value="0" />
                            <v-radio label="เข้าออกตามแผนงาน" value="1" />
                          </v-radio-group>
                        </v-flex> -->
                        <v-flex lg3 md3 sm3 xs6>
                          <v-btn color="green" dark @click="addcommission()">
                            <v-icon size="16" class="px-2">fa-plus</v-icon>
                            <span>เพิ่มเงื่อนไข</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-layout row wrap v-for="(item,i) in form_model.commission" :key="i">
                            <v-flex md2 sm3 xs6 pa-2>
                              <v-text-field
                                name="จากเวลา"
                                label="จากเวลา"
                                type="time"
                                v-model="item.start_time"
                                @blur="checktime(item,i)"
                              />
                            </v-flex>
                            <v-flex md2 sm3 xs6 pa-2>
                              <v-text-field
                                name="ถึงเวลา"
                                label="ถึงเวลา"
                                type="time"
                                v-model="item.end_time"
                                @blur="checktime(item,i)"
                              />
                            </v-flex>
                            <!-- <v-flex md2 sm3 xs6 pa-2>
                                <v-select
                                  required
                                  :items="listcom"
                                  item-text="text"
                                  item-value="code"
                                  label="ประเภทการจ่ายเงิน"
                                  v-model="item.comtype"
                                  @input="paymenttype => updatepaymenttype(paymenttype,i)"
                                />
                            </v-flex>
                            <v-flex md2 sm2 xs6 pa-2>
                              <v-text-field
                                name="จำนวน"
                                label="จำนวน"
                                v-model="item.amount"
                                type="number"
                                :min="0"
                                @change="item.amount = Math.max(Math.abs(item.amount),0)"
                              />
                            </v-flex>-->
                            <v-flex md2 sm1 xs6 pa-3 v-if="form_model.commission.length > 1">
                              <v-icon size="16" color="red" @click="delcommission(i)">fa-minus</v-icon>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea label="หมายเหตุ" v-model="form_model.remark" name="หมายเหตุ" />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapActions } from "vuex";
import SettingService from "@/services/SettingService";
import Utils from "@/utils/";

export default {
  props: {
    json_data: Object,
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
        this.form_model = val.data;
        if (this.form_model.late_conditional == undefined) {
          this.form_model.late_conditional = 0;
        }

        if (this.form_model.commission == undefined) {
          this.form_model.commission = [
            {
              start_time: "",
              end_time: "",
              comtype: 0,
              amount: 0,
            },
          ];
        }
        if (this.form_model.list_condition_late == undefined) {
          this.form_model.list_condition_late = [
            {
              timein: "",
              timeout: "",
              deducttype: 0,
              amount: 0,
            },
          ];
        }
        //  console.log(this.form_model)
      } else {
        this.$refs.form.resetValidation();
        this.doNewGuid();
      }
    },
  },
  data: () => ({
    checkconditional: true,
    form_valid: false,
    form_model: {
      code: "",
      name: "",
      remark: "",
      late_conditional: 0,
      deduct_absent_monday: 1,
      deduct_absent_tuesday: 1,
      deduct_absent_wednesday: 1,
      deduct_absent_thursday: 1,
      deduct_absent_friday: 1,
      deduct_absent_saturday: 1,
      deduct_absent_sunday: 1,
      deduct_absent_holiday: 1,
      deduct_leave_monday: 1,
      deduct_leave_tuesday: 1,
      deduct_leave_wednesday: 1,
      deduct_leave_thursday: 1,
      deduct_leave_friday: 1,
      deduct_leave_saturday: 1,
      deduct_leave_sunday: 1,
      deduct_leave_holiday: 1,
      deduct_late_bytime: "0",
      deduct_late_monday: 1,
      deduct_late_tuesday: 1,
      deduct_late_wednesday: 1,
      deduct_late_thursday: 1,
      deduct_late_friday: 1,
      deduct_late_saturday: 1,
      deduct_late_sunday: 1,
      deduct_late_holiday: 1,
      deduct_outbefore_bytime: "0",
      deduct_outbefore_monday: 1,
      deduct_outbefore_tuesday: 1,
      deduct_outbefore_wednesday: 1,
      deduct_outbefore_thursday: 1,
      deduct_outbefore_friday: 1,
      deduct_outbefore_saturday: 1,
      deduct_outbefore_sunday: 1,
      deduct_outbefore_holiday: 1,
      income_ot_monday: 1,
      income_ot_tuesday: 1,
      income_ot_wednesday: 1,
      income_ot_thursday: 1,
      income_ot_friday: 1,
      income_ot_saturday: 1,
      income_ot_sunday: 1,
      income_ot_holiday: 1,
      income_ot_bytime:"0",
      deduct_leave_bytime: "0",
      deduct_absent_bytime: "0",
      forgetscan_type:0,
      forgetscan_value:0,
      commission: [
         {
            start_time: "",
            end_time: "",
            comtype: 0,
            amount: 0,
          },
      ],
      list_condition_late: [
        {
          timein: "",
          timeout: "",
          deducttype: 0,
          amount: 0,
        },
      ],
      creator_code: localStorage._usercode,
    },
    form_rules: {
      code: [(v) => !!v || "do not empty."],
      name: [(v) => !!v || "do not empty."],
      fromtime: [(v) => !!v || "do not empty."],
      totime: [(v) => !!v || "do not empty."],
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },

    listcondition: [
      { code: 0, text: "จำนวนเงิน" },
      { code: 1, text: "หักตามค่าแรง(เท่า)" },
    ],
    listcom: [
      { code: 0, text: "จำนวนเงิน" },
      { code: 1, text: "ได้ตามค่าแรง(เท่า)" },
    ],
  }),
  methods: {
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    doNewGuid() {
      this.form_model.code = Utils.newGuid("A");
    },
    clearForm() {
      this.form_model = {
        code: "",
        name: "",
        remark: "",
        late_conditional: 0,
        deduct_absent_monday: 1,
        deduct_absent_tuesday: 1,
        deduct_absent_wednesday: 1,
        deduct_absent_thursday: 1,
        deduct_absent_friday: 1,
        deduct_absent_saturday: 1,
        deduct_absent_sunday: 1,
        deduct_absent_holiday: 1,
        deduct_leave_monday: 1,
        deduct_leave_tuesday: 1,
        deduct_leave_wednesday: 1,
        deduct_leave_thursday: 1,
        deduct_leave_friday: 1,
        deduct_leave_saturday: 1,
        deduct_leave_sunday: 1,
        deduct_leave_holiday: 1,
        deduct_late_bytime: "0",
        deduct_late_monday: 1,
        deduct_late_tuesday: 1,
        deduct_late_wednesday: 1,
        deduct_late_thursday: 1,
        deduct_late_friday: 1,
        deduct_late_saturday: 1,
        deduct_late_sunday: 1,
        deduct_late_holiday: 1,
        deduct_outbefore_bytime: "0",
        deduct_outbefore_monday: 1,
        deduct_outbefore_tuesday: 1,
        deduct_outbefore_wednesday: 1,
        deduct_outbefore_thursday: 1,
        deduct_outbefore_friday: 1,
        deduct_outbefore_saturday: 1,
        deduct_outbefore_sunday: 1,
        deduct_outbefore_holiday: 1,
        income_ot_monday: 1,
        income_ot_tuesday: 1,
        income_ot_wednesday: 1,
        income_ot_thursday: 1,
        income_ot_friday: 1,
        income_ot_saturday: 1,
        income_ot_sunday: 1,
        income_ot_holiday: 1,
        income_ot_bytime:"0",
        deduct_leave_bytime: "0",
        deduct_absent_bytime: "0",
        forgetscan_type:0,
        forgetscan_value:0,
        commission: [
          {
            start_time: "",
            end_time: "",
            comtype: 0,
            amount: 0,
          },
        ],
        list_condition_late: [
          {
            timein: "",
            timeout: "",
            deducttype: 0,
            amount: 0,
          },
        ],
        creator_code: localStorage._usercode,
      };
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    addcommission() {
      this.form_model.commission.push({
        start_time: "",
        end_time: "",
        comtype: 0,
        amount: 0,
      });
      // console.log(this.form_model.commission)
      this.$forceUpdate();
    },
    addlistconditionlate() {
      if (this.form_model.list_condition_late.length < 5) {
        this.form_model.list_condition_late.push({
          timein: "",
          timeout: "",
          deducttype: 0,
          amount: 0,
        });
      } else {
        this.showSnackBar("เพิ่มเงื่อนไขได้ไม่เกิน 5 เงื่อนไข", "error");
      }
      // console.log(this.form_model.list_condition_late)
      this.$forceUpdate();
    },
    delcommission(items) {
      let v = this;
      if (v.form_model.commission.length > 0) {
        v.form_model.commission.splice(items, 1);
      }
      this.$forceUpdate();
    },
    dellistconditionlate(items) {
      let v = this;
      if (v.form_model.list_condition_late.length > 0) {
        v.form_model.list_condition_late.splice(items, 1);
      }
      // console.log("ddd", this.form_model.list_condition_late);
      this.$forceUpdate();
    },
    updatepaymenttype(payment, index) {
      if (this.form_model.list_condition_late[index].deducttype == "ครึ่งแรง") {
        this.form_model.list_condition_late[index].amount = 0.5;
      } else if (
        this.form_model.list_condition_late[index].deducttype == "เต็มแรง"
      ) {
        this.form_model.list_condition_late[index].amount = 1;
      } else {
        this.form_model.list_condition_late[index].amount = 0;
      }
      // console.log(this.form_model.list_condition_late);
    },
    checktimelate(item, index) {
      //  console.log("items", item);
      // console.log("i", index);
      if (
        item.timein > item.timeout &&
        item.timein != "" &&
        item.timeout != ""
      ) {
        this.showSnackBar("กรุณากรอกเวลาให้ถูกต้อง", "error");
        this.checkconditional = false;
      } else {
        this.checkconditional = true;
      }
      if (this.form_model.list_condition_late.length > 1) {
        if (
          this.form_model.list_condition_late[index - 1].timeout > item.timein
        ) {
          this.showSnackBar(
            "กรุณากรอก'ตั้งแต่เวลา'ให้มากกว่า'ถึงเวลา'ก่อนหน้า",
            "error"
          );
          this.checkconditional = false;
        }
      } else {
        this.checkconditional = true;
      }
    },
    checktime(item, index) {
      //  console.log("items", item);
      // console.log("i", index);
      if (
        item.start_time > item.end_time &&
        item.start_time != "" &&
        item.end_time != ""
      ) {
        this.showSnackBar("กรุณากรอกเวลาให้ถูกต้อง", "error");
        this.checkconditional = false;
      } else {
        this.checkconditional = true;
      }
      if (this.form_model.commission.length > 1) {
        if (this.form_model.commission[index - 1].end_time > item.start_time) {
          this.showSnackBar(
            "กรุณากรอก'จากเวลา'ให้มากกว่า'ถึงเวลา'ก่อนหน้า",
            "error"
          );
          this.checkconditional = false;
        }
      } else {
        this.checkconditional = true;
      }
    },
    onSave() {
      //console.log(this.form_model);

      if (this.form_model.late_conditional == 1) {
        if (
          this.form_model.list_condition_late.length <= 1 &&
          this.form_model.list_condition_late[0].timein == ""
        ) {
          this.showSnackBar("กรุณากรอกเงื่อนไขกรณีมาสายให้ครบถ้วน", "error");
        }
      }
      if (this.form_valid && this.checkconditional) {
        for (
          let index = 0;
          index < this.form_model.list_condition_late.length;
          index++
        ) {
          if (
            this.form_model.list_condition_late[index].line_number == undefined
          ) {
            this.form_model.list_condition_late[index].line_number = index;
          } else {
            this.form_model.list_condition_late[index].line_number = index;
          }
        }
        for (let index = 0; index < this.form_model.commission.length ; index++) {
          if (this.form_model.commission[index].line_number == undefined) {
            this.form_model.commission[index].line_number = index;
            if(this.form_model.commission[index].start_time == "" && this.form_model.commission[index].end_time == "" ){
              this.form_model.commission = [];
               console.log(this.form_model);
            } 
          } 
          else {   
             this.form_model.commission[index].line_number = index;
            
          }
        }
       console.log(this.form_model);
        SettingService.createProfileConditions(this.form_model)
          .then((res) => {
            this.showSnackBar("save success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.showSnackBar("กรุณากรอกให้ครบถ้วนและถูกต้อง", "error");
        this.$refs.form.validate();
      }
    },
    onUpdate() {
       
      for ( let index = 0; index < this.form_model.list_condition_late.length; index++) {
        if (
          this.form_model.list_condition_late[index].line_number == undefined
        ) {
          this.form_model.list_condition_late[index].line_number = index;
        } else {
          this.form_model.list_condition_late[index].line_number = index;
        }
      }
      for (let index = 0; index < this.form_model.commission.length; index++) {
        if(this.form_model.commission[index].start_time != null && (this.form_model.commission[index].end_time != null || this.form_model.commission[index].end_time == null)){
          if (this.form_model.commission[index].line_number == undefined) {
           this.form_model.commission[index].line_number = index;
       if(this.form_model.commission[index].start_time == "" && this.form_model.commission[index].end_time == "" ){
              this.form_model.commission = [];
            } 
          } else {
            this.form_model.commission[index].line_number = index;
          }
        }
        else {
          
        }
      }
       console.log(this.form_model);
      if (this.form_valid && this.checkconditional) {
        this.form_model.creator_code = localStorage._usercode;
        console.log(this.form_model);
        SettingService.updateProfileConditions(this.form_model)
          .then((res) => {
            this.showSnackBar("update success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar(err.response.data, "error");
          });
      } else {
        this.$refs.form.validate();
      }
    },
    changeconditional() {
      // console.log(this.form_model.late_conditional);
      this.$forceUpdate();
    },
  },
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 0;
}

.v-text-field {
  padding-top: 6;
  margin-top: 0;
}
.v-card__text {
  padding: 0px !important;
}
</style>